// extracted by mini-css-extract-plugin
export default {"cart-inner":"ed90e4"};